/* NHG callout blocks — tap/click to expand, hover handled purely in CSS. */
(function () {
  'use strict';

  function setState(callout, open) {
    var toggle = callout.querySelector('[data-nhg-toggle]');
    callout.classList.toggle('is-open', open);
    if (!open && callout.closest('.nhg-callouts--popup')
        && window.matchMedia('(max-width: 749px)').matches) {
      document.documentElement.style.overflow = '';
    }
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(open));
    var text = toggle.querySelector('.nhg-callout__toggle-text');
    if (text) {
      text.textContent = open
        ? toggle.dataset.closeLabel || 'Close'
        : toggle.dataset.openLabel || 'See what that includes';
    }
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-nhg-callout]').forEach(function (callout) {
      if (callout.dataset.nhgReady === 'true') return;
      callout.dataset.nhgReady = 'true';

      var panel = callout.querySelector('[data-nhg-panel]');
      var scrim = callout.querySelector('[data-nhg-scrim]');
      var popup = !!callout.closest('.nhg-callouts--popup');

      /* Flip the popover above the box when it would run off the bottom. */
      function place() {
        if (!popup || !panel) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          panel.classList.remove('is-above');
          return;
        }
        panel.classList.remove('is-above');
        var box = callout.getBoundingClientRect();
        var needed = panel.offsetHeight + 20;
        var below = window.innerHeight - box.bottom;
        if (below < needed && box.top > needed) panel.classList.add('is-above');
      }

      if (popup) {
        callout.addEventListener('mouseenter', place);
        callout.addEventListener('focusin', place);
        window.addEventListener('resize', function () {
          if (callout.classList.contains('is-open')) place();
        });
      }

      if (scrim) scrim.addEventListener('click', function () { setState(callout, false); });

      var toggle = callout.querySelector('[data-nhg-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var next = !callout.classList.contains('is-open');
        if (next) place();
        setState(callout, next);
        /* Lock the page behind the mobile sheet. */
        if (popup && window.matchMedia('(max-width: 749px)').matches) {
          document.documentElement.style.overflow = next ? 'hidden' : '';
        }
      });

      callout.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && callout.classList.contains('is-open')) {
          setState(callout, false);
          toggle.focus();
        }
      });
    });
  }

  // Tapping elsewhere closes any pinned-open box.
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-nhg-callout].is-open').forEach(function (callout) {
      if (!callout.contains(event.target)) setState(callout, false);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-bind when a section or block is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var callout = e.target.querySelector('[data-nhg-callout]') || e.target.closest('[data-nhg-callout]');
    init(e.target);
    if (callout) setState(callout, true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var callout = e.target.querySelector('[data-nhg-callout]') || e.target.closest('[data-nhg-callout]');
    if (callout) setState(callout, false);
  });
})();

/* NHG enquiry modal — opened by a callout CTA, routed by data attributes. */
(function () {
  'use strict';

  var DEFAULT_ERROR = 'That didn\u2019t send. Please check your details and try again.';

  var modal, dialog, panel, done, form, lastFocused;

  function fields() {
    return {
      title: modal.querySelector('[data-nhg-modal-title]'),
      intro: modal.querySelector('[data-nhg-modal-intro]'),
      route: modal.querySelector('[data-nhg-route]'),
      set: modal.querySelector('[data-nhg-set]'),
      source: modal.querySelector('[data-nhg-source]'),
      error: modal.querySelector('[data-nhg-form-error]'),
      submit: modal.querySelector('[data-nhg-submit]'),
      submitText: modal.querySelector('[data-nhg-submit-text]')
    };
  }

  function open(trigger) {
    if (!modal) return;
    var f = fields();
    lastFocused = trigger || document.activeElement;

    if (trigger) {
      if (trigger.dataset.formTitle && f.title) f.title.textContent = trigger.dataset.formTitle;
      if (trigger.dataset.formIntro && f.intro) f.intro.textContent = trigger.dataset.formIntro;
      if (f.route) f.route.value = trigger.dataset.route || 'General';
      if (f.set) f.set.value = trigger.dataset.set || '';
      form.dataset.endpoint = trigger.dataset.endpoint || '';
    }
    if (f.source) f.source.value = window.location.pathname + window.location.search;
    clearError();

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    // The quantity gate is a <select>, so it has to be in this list or focus
    // lands on a disabled field behind the gate and goes nowhere.
    var firstField = panel.hidden
      ? dialog.querySelector('button')
      : panel.querySelector('select:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');
    if (firstField) firstField.focus({ preventScroll: true });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  // Panel visibility belongs to the inline script in nhg-callout-form.liquid,
  // which is the only thing that knows about all three panels. Going through
  // its hook stops the two scripts fighting over the same hidden attributes.
  function showSuccess() {
    if (typeof window.nhgShowDone === 'function') { window.nhgShowDone(); return; }
    panel.hidden = true;
    if (done) done.hidden = false;
  }

  function clearError() {
    if (typeof window.nhgClearError === 'function') { window.nhgClearError(); return; }
    var f = fields();
    if (f.error) { f.error.textContent = ''; f.error.hidden = true; }
  }

  function showError(message) {
    var f = fields();
    if (f.submit) f.submit.disabled = false;
    if (f.submitText) f.submitText.textContent = 'Send it over';
    if (f.error) {
      f.error.textContent = message || DEFAULT_ERROR;
      f.error.hidden = false;
    }
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || modal.hidden) return;
    var focusable = dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])'
    );
    var list = Array.prototype.filter.call(focusable, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  // Only ever fail on positive evidence of failure.
  //
  // Previous versions treated "I did not find proof of success" as failure,
  // which is why a submission that sent the email still showed an error: the
  // proof can go missing for reasons that have nothing to do with whether
  // Shopify accepted the form. Shopify announces rejections by re-rendering
  // the page with form.errors, so that is the thing worth looking for.
  function readResponse(html, res) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var posted = !!doc.querySelector('[data-nhg-posted]');

    // Shopify's own complaint, rendered by {{ form.errors | default_errors }}.
    var reported = doc.querySelector('.nhg-form__error:not([data-nhg-form-error])');
    var message = reported ? reported.textContent.trim() : '';

    if (message) throw new Error(message);  // Shopify said no.
    if (posted) return;                     // Shopify said yes.
    if (res.ok) return;                     // Nothing said no. Don't invent a failure.
    throw new Error('');
  }

  function submit(event) {
    var f = fields();

    // Honeypot tripped — pretend it worked, send nothing.
    var trap = form.querySelector('.nhg-form__trap input');
    if (trap && trap.value) { event.preventDefault(); showSuccess(); return; }

    // No fetch available: let the browser post natively and reload.
    if (!window.fetch) return;

    event.preventDefault();
    clearError();
    if (f.submit) f.submit.disabled = true;
    if (f.submitText) f.submitText.textContent = 'Sending…';

    var custom = !!form.dataset.endpoint;
    var endpoint = form.dataset.endpoint || form.getAttribute('action');
    var body = new FormData(form);

    var response = null;

    fetch(endpoint, {
      method: 'POST',
      body: body,
      headers: { Accept: custom ? 'application/json' : 'text/html' }
    })
      .then(function (res) {
        response = res;
        if (custom) {
          if (!res.ok) throw new Error('');
          return null;
        }
        return res.text();
      })
      .then(function (html) {
        if (html !== null) readResponse(html, response);
      })
      // Two callbacks rather than .catch(): a .catch() here would also fire on
      // an exception thrown inside showSuccess, painting a failure message over
      // a submission that succeeded. This form can only ever run one of them.
      .then(
        function () { showSuccess(); },
        function (err) {
          // If this ever fires again, these three values say why.
          console.warn('[nhg] submission treated as failed', {
            status: response ? response.status : 'no response — network or CORS',
            url: response ? response.url : '',
            reason: (err && err.message) || 'no message'
          });
          showError(err && err.message);
        }
      );
  }

  function init() {
    modal = document.querySelector('[data-nhg-modal]');
    if (!modal || modal.dataset.nhgReady === 'true') return;
    modal.dataset.nhgReady = 'true';

    dialog = modal.querySelector('.nhg-modal__dialog');
    panel = modal.querySelector('[data-nhg-modal-panel]');
    done = modal.querySelector('[data-nhg-modal-done]');
    form = modal.querySelector('[data-nhg-form]') || modal.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', submit);

    modal.querySelectorAll('[data-nhg-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      trapFocus(event);
    });

    // Delegated so callouts added later (theme editor, AJAX) still work.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-nhg-open-form]');
      if (trigger) { event.preventDefault(); open(trigger); }
    });

    // The non-JS fallback (page reloads after a real POST) is handled by the
    // inline script in nhg-callout-form.liquid, which checks for the
    // [data-nhg-posted] marker. It used to be duplicated here off the query
    // string alone, which fired on any URL carrying that parameter — including
    // a refresh or a back-button visit after a failed submission.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();